module.exports = __webpack_public_path__ + "static/img_22-f1a73a7074f8c0a50d545f7826d442f3.png";